document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("contributionTypeForm");
  if (!form) return;

  const categorySelect = document.getElementById("contribution_type_category");
  const sharePriceField = document.getElementById("sharePriceField");

  // Toggle share price field based on category
  if (categorySelect) {
    categorySelect.addEventListener("change", function () {
      if (this.value === "hisa") {
        sharePriceField.style.display = "block";
      } else {
        sharePriceField.style.display = "none";
      }
    });
  }

  // Hydrate modal fields on edit
  document.querySelectorAll("[data-action='edit']").forEach(link => {
    link.addEventListener("click", function () {
      form.dataset.contributionTypeId = this.dataset.contributionTypeId;

      document.getElementById("contribution_type_name").value = this.dataset.name || "";
      document.getElementById("contribution_type_category").value = this.dataset.category || "";
      document.getElementById("contribution_type_fixed_amount").value = this.dataset.fixedAmount || "";
      document.getElementById("contribution_type_minimum_amount").value = this.dataset.minimumAmount || "";
      document.getElementById("contribution_type_maximum_amount").value = this.dataset.maximumAmount || "";
      document.getElementById("contribution_type_share_price").value = this.dataset.sharePrice || "";

      // Show/hide share price field based on category
      if (this.dataset.category === "hisa") {
        sharePriceField.style.display = "block";
      } else {
        sharePriceField.style.display = "none";
      }
    });
  });

  // Reset form on new
  document.querySelectorAll("[data-action='new']").forEach(link => {
    link.addEventListener("click", function () {
      form.dataset.contributionTypeId = "";

      document.getElementById("contribution_type_name").value = "";
      document.getElementById("contribution_type_category").value = "";
      document.getElementById("contribution_type_fixed_amount").value = "";
      document.getElementById("contribution_type_minimum_amount").value = "";
      document.getElementById("contribution_type_maximum_amount").value = "";
      document.getElementById("contribution_type_share_price").value = "";

      sharePriceField.style.display = "none";
    });
  });

  // Save handler
  document.getElementById("saveContributionTypeBtn").onclick = function () {
    const payload = {
      name: document.getElementById("contribution_type_name").value,       // user label
      category: document.getElementById("contribution_type_category").value, // enum category
      fixed_amount: document.getElementById("contribution_type_fixed_amount").value,
      minimum_amount: document.getElementById("contribution_type_minimum_amount").value,
      maximum_amount: document.getElementById("contribution_type_maximum_amount").value,
      share_price: document.getElementById("contribution_type_share_price").value
    };

    const url = form.dataset.contributionTypeId
      ? `/contribution_types/${form.dataset.contributionTypeId}`
      : "/contribution_types";
    const method = form.dataset.contributionTypeId ? "PATCH" : "POST";

    fetch(url, {
      method: method,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content
      },
      body: JSON.stringify({ contribution_type: payload })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        location.reload();
      } else {
        alert(data.errors.join(", "));
      }
    });
  };
});
